import React from "react";
import {
  CardModalOverlay,
  CardModalContainer,
  CardModalWrapper,
  ModalTitle,
  CardModalDescription,
  CloseLink,
} from "./style";

interface Props {
  open: boolean;
  onClose: () => void;
}

const CardInfoModal: React.FC<Props> = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <CardModalOverlay onClick={onClose}>
      <CardModalContainer onClick={(e) => e.stopPropagation()}>
        <CardModalWrapper>
          <ModalTitle style={{ marginTop: "0px" }}>E-Learning</ModalTitle>

          <CardModalDescription>
            Through various multimedia and interactive activities, this online
            module will teach you more about this course topic. Then, there will be a brief
            assessment to check your knowledge.
          </CardModalDescription>

          <CloseLink onClick={onClose}>Tap to close</CloseLink>
        </CardModalWrapper>
      </CardModalContainer>
    </CardModalOverlay>
  );
};

export default CardInfoModal;